import Vue from 'vue'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import components from '@/utils/components'
import store from "@/store"
import App from './App.vue'
import router from './router'
import './custom.scss'
// import 'swiper/dist/css/swiper.min.css'
import 'swiper/dist/css/swiper.css'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import Storage from 'vue-ls';
import 'animate.css';
import LoadingOverlay from "@comp/LoadingOverlay.vue";
import MessagePlugin from "@/utils/messagePlugin";

const metaTitle= 'C & I 配件官网';
const metaKeywords= 'C & I 配件官网|IC配件|华强北|配件出售';
const metaDescription= '全网最全的配件出售官网';

Vue.use(VueAwesomeSwiper, /* { 全局组件的默认选项 } */)
const options = {
  namespace: 'vuejs__', // key键前缀
  name: 'ls', // 命名Vue变量.[ls]或this.[$ls],
  storage: 'local', // 存储名称: session, local, memory
};
Vue.use(MessagePlugin); // 使用插件
Vue.use(Storage, options);
// Install BootstrapVue
Vue.use(BootstrapVue)
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin)
Vue.component('LoadingOverlay', LoadingOverlay);
//注册自定义组件
for (let key in components) {
  Vue.component(key,components[key]);
}


Vue.prototype.$initMeta = (title, keywords, description)=>{
  // 获取或创建meta标签
  let titleEl = document.querySelector('title');
  let titleMeta = document.querySelector('meta[name="title"]');
  if (!titleMeta) {
    titleMeta = document.createElement('meta');
    titleMeta.setAttribute('name', 'title');
    document.head.appendChild(titleMeta);
  }
  if (!titleEl) {
    titleEl = document.createElement('title');
    document.head.appendChild(titleEl);
  }
  if(!!title) {
    titleEl.innerHTML = title;
    titleMeta.setAttribute('content', title);
  } /*else {
    titleEl.innerHTML = metaTitle;
    titleMeta.setAttribute('content', metaTitle);
  }*/

  let keywordsMeta = document.querySelector('meta[name="keywords"]');
  if (!keywordsMeta) {
    keywordsMeta = document.createElement('meta');
    keywordsMeta.setAttribute('name', 'keywords');
    document.head.appendChild(keywordsMeta);
  }
  if(keywords) {
    keywordsMeta.setAttribute('content', keywords);
  } /*else {
    keywordsMeta.setAttribute('content', metaKeywords);
  }*/


  let descriptionMeta = document.querySelector('meta[name="description"]');
  if (!descriptionMeta) {
    descriptionMeta = document.createElement('meta');
    descriptionMeta.setAttribute('name', 'description');
    document.head.appendChild(descriptionMeta);
  }
  if(description) {
    descriptionMeta.setAttribute('content', description);
  } /*else {
    descriptionMeta.setAttribute('content', metaDescription);
  }*/
};

// 关闭NavigationDuplicated警告
// Vue.config.productionTip = false;


new Vue({
  render: h => h(App),
  store,
  router,
}).$mount('#app')
